import { fetchAll, fetchFiltered, addManufacturer, show, edit } from '@/api/manufacturer'

const state = {
  all: [],
  isLoading: false,
  manufacturerById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const manufacturer = await show(id)
      commit('setManufacturerById', manufacturer)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const manufacturers = await fetchAll()
      commit('setAll', manufacturers)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const manufacturers = await fetchFiltered(queriesParams)
      commit('setAll', manufacturers)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addManufacturer(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.manufacturerById = null
  },

  setAll (state, manufacturer) {
    state.all = manufacturer
  },

  setManufacturerById (state, manufacturer) {
    state.manufacturerById = {
      id: manufacturer.id,
      name: manufacturer.name,
      isActive: manufacturer.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
